import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicDisableMixin {
  disabled: boolean | undefined;
}
export type DynamicDisableCtor = Constructor<IDynamicDisableMixin>;

export function mixinDynamicDisable<T extends Constructor<{}>>(base: T): DynamicDisableCtor & T {
  class DynamicDisableMixin extends base implements IDynamicDisableMixin {
    @DynamicProperty() disabled: boolean | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicDisableMixin;
}
